import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
interface CountdownTimerProps {
  variant?: 'dark' | 'light' | 'red';
  className?: string;
}
export const CountdownTimer: React.FC<CountdownTimerProps> = ({
  variant = 'dark',
  className = ''
}) => {
  const {
    minutes,
    seconds
  } = useCountdown();
  const getStyles = () => {
    switch (variant) {
      case 'light':
        return 'bg-white text-blue-900';
      case 'red':
        return 'bg-red-600 text-white';
      case 'dark':
      default:
        return 'bg-gray-900 text-white';
    }
  };
  const blockClass = `flex items-center justify-center w-10 h-10 rounded-lg font-bold text-lg ${getStyles()}`;
  return <div className={`flex items-center gap-2 ${className}`} data-id="element-36">
      <div className="flex flex-col items-center" data-id="element-37">
        <div className={blockClass} data-id="element-38">00</div>
        <span className="text-[10px] uppercase mt-1 opacity-80" data-id="element-39">Horas</span>
      </div>
      <span className="text-xl font-bold pb-4" data-id="element-40">:</span>
      <div className="flex flex-col items-center" data-id="element-41">
        <div className={blockClass} data-id="element-42">{minutes}</div>
        <span className="text-[10px] uppercase mt-1 opacity-80" data-id="element-43">Min</span>
      </div>
      <span className="text-xl font-bold pb-4" data-id="element-44">:</span>
      <div className="flex flex-col items-center" data-id="element-45">
        <div className={blockClass} data-id="element-46">{seconds}</div>
        <span className="text-[10px] uppercase mt-1 opacity-80" data-id="element-47">Seg</span>
      </div>
    </div>;
};